import {
  PATH_NAME_CATEGORY_SEARCH,
  PATH_NAME_SEARCH,
  PATH_NAME_SEARCH_TAG,
  PATH_NAME_SEARCH_TAG_GROUP
} from '@/common/resources/router.const'
import { SEARCH_TAB_LIST } from '@/common/resources/const'
import _ from 'lodash'

export default [
  {
    path: 'category/:id',
    name: PATH_NAME_CATEGORY_SEARCH,
    components: {
      bodyContent: () => import(/* webpackChunkName "categorySearch" */'@/pages/list/Category')
    },
    props: true
  },
  {
    path: 'search/search',
    name: PATH_NAME_SEARCH,
    alias: '/search/search.html',
    components: {
      searchContent: () => import(/* webpackChunkName: "search" */'@/pages/search/Search')
    },
    beforeEnter: (to, from, next) => {
      const tabList = SEARCH_TAB_LIST
      const currCategory = _.get(to, 'query.category', 'all')
      const currMtype = _.get(to, 'query.mtype', '')
      const categoryIndex = _.findIndex(tabList, (tab) => {
        return tab.type === currCategory
      })
      const targetMtype = _.get(tabList, [categoryIndex, 'subType', 'mtype'], '')
      if (currMtype === '' && targetMtype !== '') {
        next({
          name: PATH_NAME_SEARCH,
          query: Object.assign(to.query, tabList[categoryIndex].subType)
        })
      } else {
        next()
      }
    }
  },
  {
    path: 'search/search_tag',
    name: PATH_NAME_SEARCH_TAG,
    alias: '/search/search_tag.html',
    components: {
      searchContent: () => import(/* webpackChunkName: "search_tag" */'@/pages/search/search_tag')
    }
  },
  {
    path: 'search/search_tag_group',
    name: PATH_NAME_SEARCH_TAG_GROUP,
    alias: '/search/search_tag_group.html',
    components: {
      searchContent: () => import(/* webpackChunkName: "search_tag_group" */'@/pages/search/search_tag_group')
    }
  }
]
